export function hasMarketingWordSymbol(name) {
    return /[【】]/.test(name);
}

/**
 * 组装 skuName
 */
export function assembleSKUName(marketingWord, commodityName) {
    return `${marketingWord ? `【${marketingWord}】` : ''}${commodityName || ''}`;
}

/**
 * 拆分商品名为 marketingWord 和 commodityName
 * @param {string} skuName 商品名
 * @returns {Object} 包含 marketingWord 和 commodityName 的对象
 */
export function splitSKUName(skuName) {
    const match = skuName.match(/^【(.*?)】(.*)$/);
    if (match) {
        return {
            marketingWord: match[1] || '', // 【】中的内容
            commodityName: match[2] || '', // 剩余的商品名
        };
    }
    return {
        marketingWord: '', // 如果没有【】，marketingWord 为空
        commodityName: skuName || '', // 整个 skuName 作为 commodityName
    };
}

/**
 * 将对象中的商品名，拆分为 marketingWord 和 commodityName，并自动写入到对象中
 * @param {Object} 包含 skuName 的对象
 */
export function splitObjectSKUName(obj) {
    if (!obj?.skuName) return;
    const { skuName } = obj;
    const { marketingWord, commodityName } = splitSKUName(skuName);
    obj.marketingWord = marketingWord;
    obj.commodityName = commodityName;
}
